<template>
  1.3.3v
  <div id="nav">
    <router-link class="driver-list" :to="{ name : 'DriverList' }">Drivers</router-link>
    <router-link class="graph" :to="{ name : 'Graph' }">Graph</router-link>
    <router-link class="about" :to="{ name : 'About' }">About</router-link>
  </div>
  <router-view />
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
